export const enum Cohort {
  INTL_1 = 'intl_1',
  INTL_1T = 'intl_1t',
  INTL_2 = 'intl_2',
  INTL_2LW = 'intl_2lw',
  INTL_D60 = 'intl_d60',
  INTL_D70 = 'intl_d70',
  INTL_HLWN70 = 'intl_hlwn70',
  INTL_MW = 'intl_mw',
  INTL_3 = 'intl_3',
}

export const LOCALES = {
  EN: 'en',
  FR: 'fr',
  DE: 'de',
}

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}

export const enum CurrentEnvironment {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
  DEV02 = 'dev02',
  STAGE_QA = 'stage-qa',
}

export const NOVE8_SUBSCRIPTIONS_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'subscriptions.supernove8.com',
  [CurrentEnvironment.STAGE]: 'subscriptions.meganove8.com',
  [CurrentEnvironment.PROD]: 'subscriptions.nove8.com',
  [CurrentEnvironment.DEV02]: 'subscriptions-dev02.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'subscriptions-qa.meganove8.com',
}

export const NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'VnRTLf6D5hQHNeee8',
  [CurrentEnvironment.STAGE]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.PROD]: 'T4mdUKu0bCF54xkAyb7HslwWLZKkJTVG1',
  [CurrentEnvironment.DEV02]: 'VnRTLf6D5hQHNeee8',
  [CurrentEnvironment.STAGE_QA]: 'QA7KdN3P9MqrstuVXYZ1234ABCDeFgHiJk',
}

export const INTELLIO_TOOLS_API_LINKS = {
  [CurrentEnvironment.DEV]: 'https://intellio-tools.meganove8.com',
  [CurrentEnvironment.STAGE]: 'https://intellio-tools.meganove8.com',
  [CurrentEnvironment.STAGE_QA]: 'https://intellio-tools.meganove8.com',
  [CurrentEnvironment.DEV02]: 'https://intellio-tools.meganove8.com',
  [CurrentEnvironment.PROD]: 'https://intellio-tools.nove8.com',
}

export const INTELLIO_TOOLS_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.STAGE]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.STAGE_QA]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.DEV02]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.PROD]: 'T4mdUKu0bCF54xkAyb7HslwWLZKkJTVG1',
}

export const APP_NAME = 'intellio'

export const DEFAULT_COHORT = Cohort.INTL_2

export const LANG_QUERY_PARAM = 'lang'
export const INITIAL_LANGUAGE = 'en'

export const SUPPORTED_LOCALES: string[] = [LOCALES.EN, LOCALES.FR, LOCALES.DE]

export const enum ProcessingKey {
  GET_FIRST_LEAD = 'GET_FIRST_LEAD',
  FETCH_LEAD = 'FETCH_LEAD',
  UPDATE_LEAD_WITH_EMAIL = 'UPDATE_LEAD_WITH_EMAIL',
  CREATE_LEAD = 'CREATE_LEAD',
  CREATE_COHORT_LEAD = 'CREATE_COHORT_LEAD',
  FETCH_BREEDS = 'FETCH_BREEDS',
  FETCH_COMMANDS = 'FETCH_COMMANDS',
  CREATE_USER_ACCOUNT = 'CREATE_USER_ACCOUNT',
  SAVE_USER_ANSWER = 'SAVE_USER_ANSWER',
  CREATE_FIREBASE_USER_WITH_EMAIL_AND_PASSWORD = 'CREATE_FIREBASE_USER_WITH_EMAIL_AND_PASSWORD',
  PURCHASE_PAYPAL = 'PURCHASE_PAYPAL',
  PURCHASE_STRIPE = 'PURCHASE_STRIPE',
  PURCHASE_PAYPAL_PENDING = 'PURCHASE_PAYPAL_PENDING',
  PURCHASE_STRIPE_PENDING = 'PURCHASE_STRIPE_PENDING',
  PURCHASE_UPSELL = 'PURCHASE_UPSELL',
  PURCHASE_UPSELL_PENDING = 'PURCHASE_UPSELL_PENDING',
  PURCHASE_CHAT_UPSELL = 'PURCHASE_CHAT_UPSELL',
  PURCHASE_CHAT_UPSELL_PENDING = 'PURCHASE_CHAT_UPSELL_PENDING',
  FETCH_PREDICTED_LTV = 'FETCH_PREDICTED_LTV',
  FETCH_GEO_DATA = 'FETCH_GEO_DATA',
  FETCH_PLANS = 'FETCH_PLANS',
  LEARNWORLDS_SSO_LINK = 'LEARNWORLDS_SSO_LINK',
}

export const enum GlobalError {
  COMMON_ERROR = 'something went wrong',
  USER_HAS_NEW_SUBSCRIPTION_ERROR = 'error during the purchase process',
  USER_HAS_EXPIRED_TOKEN_ERROR = 'user has expired token',
  COMMON_PURCHASE_ERROR = 'something went wrong in purchase',
  PURCHASE_PLAN_RESPONSE_ERROR = 'something went wrong in PurchasePlanResponse',
  PURCHASE_UPSELL_RESPONSE_ERROR = 'something went wrong in PurchaseUpsellResponse',
  PURCHASE_CHAT_UPSELL_RESPONSE_ERROR = 'something went wrong in PurchaseChatUpsellResponse',
}

export const enum InputValidationText {
  EMAIL_EXISTS = 'validation.emailExists',
  INVALID_EMAIL = 'validation.invalidEmail',
  INVALID_EMAIL_VARIANT_2 = 'validation.invalidEmailVariant2',
  EMPTY_EMAIL_ERROR = 'validation.emptyEmail',
  SHORT_PASSWORD = 'validation.shortPassword',
  WRONG_CONFIRMATION_PASSWORD = 'validation.notEqualPassword',
  WRONG_PASSWORD = 'validation.wrongPassword',
  WRONG_EMAIL = 'validation.wrongEmail',
  INVALID_TEXT = 'validation.invalidText',
}

export const enum FirebaseSignUpErrorCode {
  EMAIL_EXISTS = 'auth/email-already-in-use',
}

export const enum PaymentSystem {
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export const enum FirebaseRemoteConfigKey {
  ABTEST_WEB_93_TESTTEST = 'abtest_web_93_testtest',
}

export const enum GrowthbookKey {
  ABTEST_WEB_130_BLOCK_PREPAID_CARD = 'abtest_web_130_block_prepaid_card',
  ABTEST_WEB_132_HALLOWEEN = 'abtest_web_132_halloween',
  ABTEST_WEB_147_START_SCREEN_COPY = 'abtest_web_147_start_screen_copy',
  ABTEST_WEB_238_GBP_PRICING = 'abtest_web_238_gbp_pricing',
  ABTEST_WEB_127_FIRST_SCREEN = 'abtest_web_127_first_screen',
  ABTEST_WEB_276_CHECKOUT_REDESIGN = 'abtest_intl_web_checkout', //'abtest_web_276_checkout_redesign',
  ABTEST_WEB_301_EMAIL_URGENCY = 'abtest_web_301_email_urgency',
}

export const enum GrowthbookTestGroup {
  ABTEST_WEB_132_A_DEFAULT = 'abtest_web_132_a_default',
  ABTEST_WEB_132_B_HALLOWEEN = 'abtest_web_132_b_halloween',
  ABTEST_WEB_147_A_DEFAULT = 'abtest_web_147_a_default',
  ABTEST_WEB_147_B_START_SCREEN_COPY = 'abtest_web_147_b_start_screen_copy',
  ABTEST_WEB_301_A_DEFAULT = 'abtest_web_301_a_default',
  ABTEST_WEB_301_B_EMAIL_URGENCY = 'abtest_web_301_b_email_urgency',
}

export const GROWTHBOOK_FUNNELS_CONFIG_KEY = 'intl_funnels_config_file'

export interface IPaymentMethodsConfigProps {
  paypalMethodShown: boolean
  cardMethodShown: boolean
  applePayMethodShown: boolean
  googlePayMethodShown: boolean
}

export interface ISignUpMethodsConfigProps {
  chooseOtherMethodsShown: boolean
  otherMethodsShown: {
    facebook: boolean
    apple: boolean
    google: boolean
  }
}

export interface IWebFunnelsConfigFile extends IPaymentMethodsConfigProps {
  signUpMethods: ISignUpMethodsConfigProps
  caCmpl: boolean | null
  usCmpl: boolean | null
  nycCmpl: boolean | null
  gbCmpl: boolean | null
}

export const DEFAULT_SIGN_UP_METHODS_CONFIG: ISignUpMethodsConfigProps = {
  chooseOtherMethodsShown: false,
  otherMethodsShown: {
    facebook: false,
    apple: false,
    google: false,
  },
}

export const DEFAULT_WEB_FUNNELS_CONFIG_FILE: IWebFunnelsConfigFile = {
  paypalMethodShown: true,
  cardMethodShown: true,
  applePayMethodShown: true,
  googlePayMethodShown: true,
  signUpMethods: DEFAULT_SIGN_UP_METHODS_CONFIG,
  caCmpl: null,
  usCmpl: null,
  nycCmpl: null,
  gbCmpl: null,
}

export const enum FirebaseRemoteConfigTestGroup {
  ABTEST_WEB_93_B_TEST = 'abtest_web_93_b_test',
  ABTEST_WEB_127_A_DEFAULT = 'abtest_web_127_a_default',
  ABTEST_WEB_127_B_CREATIVE_VISUAL = 'abtest_web_127_b_creative_visual',
  ABTEST_WEB_127_C_IQ_CERTIFICATE = 'abtest_web_127_c_iq_certificate',
  ABTEST_WEB_130_A_DEFAULT = 'abtest_web_intellio_a_default',
  ABTEST_WEB_130_B_PREPAID_BLOCK = 'abtest_web_intellio_b_prepaid_block',
}

export const enum HeaderId {
  BACK_LOGO_MENU_TIMER = 'back_logo_menu_timer',
  BACK_LOGO_MENU = 'back_logo_menu',
  LOGO_MENU = 'logo_menu',
  LOGO_ONLY = 'logo_only',
  POLICY = 'policy',
}

export const OPTIMIZED_VARIANT_ID = 'no_test'

// Analytics
export const enum EventLoggerInstanceName {
  AMPLITUDE = 'amplitude',
  RUDDERSTACK = 'rudderstack',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

// AppLovin (Axon)
export const AXON_PUZZLES_CATEGORY_ID = 3867
export const LOGO_IMAGE_URL = 'https://intellio.club/intellio-logo.png'

export const RUDDERSTACK_DATA_PLANE_URL = `${window.location.origin}/revents`

export const enum LoginMethod {
  EMAIL = 'email',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const enum PagePath {
  LOCALHOST = 'localhost',
  TUTORIAL = 'tutorial',
  SUBSCRIPTIONS = 'subscriptions',
}

// EMAIL
export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const EMAIL_DOMAINS = [
  '@gmail.com',
  '@hotmail.com',
  '@yahoo.com',
  '@outlook.com',
  '@aol.com',
  '@icloud.com',
  '@live.com',
  '@msn.com',
  '@me.com',
  '@mac.com',
  '@googlemail.com',
  '@facebook.com',
  '@verizon.net',
  '@rediffmail.com',
  '@zohomail.com',
  '@zoho.com',
  '@mail.com',
]

export const MANAGE_SUBSCRIPTION_LINK =
  'https://account.nove8.com/intellio/refund-contact-us'

export const COUNTRIES_WITH_MANAGE_SUBSCRIPTION_BUTTON = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'NO',
  'IS',
  'CH',
  'LI',
]

export const AMPLITUDE_API_KEY = 'f70921cb6040e9e59c97a69707147338'
